module.exports = __webpack_public_path__ + "static/image/promotion-p4.svg?8cd6e97347e22e3a42b0b50a271efc09";